export default {
  menu: 'Pricing',
  title: 'Pricing',

  table: {
    header: {
      rowNumber: 'Row',
      name: 'Title',
      code: 'Code',
      barcode: 'Barcode',
      score: 'Point',
      price: 'Retail price',
      inventoryCount: 'Inventory',
      salePrice: 'Sale price',
      purchasePrice: 'Purchase price',
      purchaseAvgPrice: 'Purchase Avg. price',
      image: 'Photo',
      category: 'Category',
      variant: 'Variable',
      creator: 'Creator',
      type: 'Type',
      status: 'Status',
      shops: 'Ecommerce',
      lastModifiedDate: 'Update'
    },

    filters: {
      type: {
        all: 'All',
        simpleProduct: 'simple goods',
        variableProduct: 'Variable Goods'
      }
    }
  },

  notifications: {
    edit: {
      success: 'Prices of the product were successfully updated',
      error: 'Updated the prices of the product with the error'
    }
  },

  validators: {
    price: 'The price is not valid',
    salePrice: 'The sale price is not valid'
  },

  status: {
    notConnect: 'no connection',
    draft: 'draft',
    waiting: 'pending',
    published: 'published',
    personal: 'private'
  }
}
